<div class="content">
  <div class="close">
    <button (click)="close()">
      <img
        alt="close"
        width="20"
        height="20"
        src="../../../assets/images/close.svg"
      />
    </button>
  </div>
  <div class="main">
    <div class="title">温馨提示</div>
    <img
      src="../../../../assets/images/fleet-dialog-tip.svg"
      [width]="114"
      [height]="84"
      alt=""
    />
    <div class="text">{{ data }}车辆状态异常，请更换其他车辆</div>
  </div>
</div>
